import { supabase } from "@/lib/supabase/supabaseClient";
import { GetProjectsByOrgIdAndCrmSystemProps } from ".";
import { DEFAULT_CRM_SYSTEM } from "@/features/crm_system/lib/_core/crmSystem/crmSystem.constants.gen";


export const getProjectsByOrgIdAndCrmSystem = async ({
    orgId,
    archived = false,
    sortByCreatedAtAscending = false,
    crmSystem = DEFAULT_CRM_SYSTEM,
}: GetProjectsByOrgIdAndCrmSystemProps) => {
    const { data } = await supabase.from('project')
        .select('*')
        .eq('organisation_id', orgId)
        .eq('crm_system', crmSystem)
        .eq('archived', archived)
        .order('created_at', { ascending: sortByCreatedAtAscending })
        .throwOnError();
    return data;
}